import VerifiedIcon from "@mui/icons-material/Verified";
import { CircularProgress, useTheme } from "@mui/material";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import ProfileModal from "../../../components/ProfileModal";
import { useAppSelector } from "../../../hooks";
import useBasicProfile from "../../../hooks/useBasicProfile";
import {
  initRoomInfomation,
  setLastBToCTarget,
  setNext,
  setPrevious,
  setIsScrollAbove,
} from "../../../store/reducers/bToCState";
import { TBToCMessage } from "../../../types/types";
import api, { API_GET_NOTIFICATION_UNREAD, getProticoClient } from "../../../utils/api";
import { notEmpty, removeWWWPrefix } from "../../../utils/format.utils";
import ChatInput from "./ChatInput";
import ChatItem from "./ChatItem";
import BToCFloatPlugin from "../BtoCFloatPlugin";
import ChatTyping from "./ChatTyping";
import InfiniteScroll from "../../../components/InfiniteScroll";
import { useBToCWebsocket } from "../../../hooks/useBtoCWebsocket";
import { MessageList } from "../../WhiteBoard/WhiteBoardMessage/WhiteBoardMessage.styles";
import { useWhiteboardRoom } from "../../../hooks/useWhiteboardRoom";
import { getSecrets } from "../../../config";
import { useWeb3Auth } from "../../../hooks/useWeb3Auth";

type Prop = {
  toDomain: string;
};

const Chat: React.FC<Prop> = ({ toDomain }) => {
  const { LOGO_BASE_URL } = getSecrets();
  const { logoUrl, roomDomain, setNotificationUnreadCount } = useWhiteboardRoom();
  const { realAddress } = useWeb3Auth();
  const theme = useTheme();
  const lowerCaseToAddress = toDomain.toLowerCase();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [profileModalVisible, setProfileModalVisible] = useState(false);
  const { roomInformations, next, previous } = useAppSelector(
    (state) => state.bToCState
  );
  const { basicProfile } = useBasicProfile(toDomain);
  const { currentAddress, authenticateStatus } = useAppSelector(
    (state) => state.auth
  );
  const { handleNewMessages, shouldScrollToBottom, cleanShouldScrollToBottom } =
    useBToCWebsocket();
  const [listModalstatus, setlistModalstatus] = useState(false);
  const [assetstatus, setAsset] = useState({
    imageUrl: "",
    permalink: "",
    name: "",
    tokenId: 0,
    assetContract: "",
    itemType: "",
  });
  const [buyModalstatus, setbuyModalstatus] = useState({
    messageid: "",
    status: false,
    setbuyModalstatus: "",
    data: {},
    type: "dm",
  });
  const { secondFontColor } = useAppSelector((state) => state.layout);
  const [isPending, setIsPending] = useState<boolean>(false);
  const messagesEndRef = useRef<null | HTMLDivElement>(null);
  const mainRoomInfo = roomInformations[lowerCaseToAddress]; //TODO: this might be undefined when it is not loaded
  const isOtherTyping = mainRoomInfo?.isOtherTyping;
  /** isOtherJoined is true when the target is looking at chat*/
  const messageList = useMemo(() => {
    if (!mainRoomInfo) return [];
    let messages: Array<TBToCMessage> = [];
    for (const [id, message] of Object.entries(mainRoomInfo.messageList)) {
      messages.push(message);
    }
    messages.sort(
      (a, b) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
    );
    return messages;
  }, [mainRoomInfo?.messageList]);
  const roomLogo = useMemo(() => {
    console.log(messageList)
    if (roomDomain == toDomain && logoUrl) {
      return logoUrl;
    }
    if (messageList[0]?.logoUrl != "" && messageList[0]?.logoUrl != null) {
      return LOGO_BASE_URL + removeWWWPrefix(toDomain) + "/" + messageList[0].logoUrl;
    }
    return "";
  }, [messageList, logoUrl]);
  const scrollToBottom = () => {
    messagesEndRef?.current?.scrollIntoView();
  };
  useEffect(() => {
    if (toDomain) dispatch(setLastBToCTarget({ toDomain }));
  }, [toDomain]);

  const fetchData = async () => {
    if (!next) return;
    try {
      const response = await getProticoClient().api.get(next.url);
      const resMessages = response.data.results as any[];
      if (resMessages.length !== 0) {
        dispatch(
          setNext({
            id: resMessages[0].id,
            createdAt: resMessages[0].created_at,
            url: response.data.next,
          })
        );
        handleNewMessages(resMessages);
      } else {
        dispatch(setNext(null));
      }
    } catch (err) {
      console.log(err);
      return;
    }
  };

  const fetchPreviousData = async () => {
    if (!previous) return;
    try {
      const response = await api.get(previous.url);
      const resMessages = response.data.results as any[];
      if (resMessages.length !== 0) {
        dispatch(
          setPrevious({
            id: resMessages[0].id,
            createdAt: resMessages[0].created_at,
            url: response.data.previous,
          })
        );
        handleNewMessages(resMessages);
      } else {
        dispatch(setPrevious(null));
      }
    } catch (err) {
      return;
    }
  };
  const parse_url_first_letter = (url: string) => {
    if (url.includes("https://")) {
      return url.split("https://")[1][0].toUpperCase();
    } else if (url.includes("http://")) {
      return url.split("http://")[1][0].toUpperCase();
    } else {
      return url[0].toUpperCase();
    }
  };

  useEffect(() => {
    // TODO: get history
    setIsPending(true);
    dispatch(setNext(null));
    dispatch(setPrevious(null));
    getProticoClient()
      .bToCMessages.getHistory(currentAddress, toDomain)
      .then((historyMessageList) => {
        const processedMessages = historyMessageList.results
          .map((historyMessage) => {
            try {
              return {
                ...historyMessage,
                sended: true,
              } as unknown as TBToCMessage;
            } catch (_) {
              return undefined;
            }
          })
          .filter(notEmpty);
        dispatch(
          initRoomInfomation({
            toDomain,
            historyMessageList: processedMessages,
          })
        );
        if (processedMessages.length !== 0) {
          setTimeout(() => {
            dispatch(
              setNext({
                id: processedMessages[0].id,
                createdAt: processedMessages[0].createdAt,
                url: historyMessageList.next,
              })
            );
            dispatch(
              setPrevious({
                id: processedMessages[processedMessages.length - 1].id,
                createdAt:
                  processedMessages[processedMessages.length - 1].createdAt,
                url: historyMessageList.previous,
              })
            );
          }, 0);
          getProticoClient().api.get(API_GET_NOTIFICATION_UNREAD).then((response) => {
              setNotificationUnreadCount(response.data.count);
            
          });

        }
        
        setIsPending(false);
      });
  }, [toDomain]);

  const handleSetIsScrollAbove = (isScrollAbove: boolean) => {
    dispatch(setIsScrollAbove(isScrollAbove));
  };

  useEffect(() => {
    if (shouldScrollToBottom) {
      setTimeout(() => {
        scrollToBottom();
      }, 0);
      cleanShouldScrollToBottom();
    }
  }, [shouldScrollToBottom]);

  const getMessageView = () => {
    if (!basicProfile)
      return (
        <div
          className="chat-empty-message-text"
          style={{ color: secondFontColor }}
        >
          {t("DM_Connecting")}
        </div>
      );
    if (messageList.length <= 0 && !isOtherTyping)
      return (
        <div
          className="chat-empty-message-text"
          style={{ color: secondFontColor }}
        >
          {t("B_TO_C_Start_1")}
          <br />
          {t("DM_Start_2")}
        </div>
      );
    return (
      <>
        <div ref={messagesEndRef} />
        {messageList.length > 1 ? (
          <InfiniteScroll
            dataLength={messageList.length}
            next={fetchData}
            previous={fetchPreviousData}
            hasMore={!!next?.url}
            hasPrevious={!!previous?.url}
            inverse={true}
            setIsScrollAbove={handleSetIsScrollAbove}
            loader={
              <div style={{ padding: "5px 10px" }}>
                <CircularProgress
                  style={{ color: theme.brandColor }}
                  size={20}
                />
              </div>
            }
            scrollableTarget="messagelist"
          >
            {messageList.map((message, index) => (
              <ChatItem
                key={`ChatItem_${index}`}
                profileData={basicProfile}
                message={message}
                toDomain={toDomain}
                scrollToBottom={scrollToBottom}
                setbuyModalstatus={setbuyModalstatus}
                roomLogo={roomLogo}
              />
            ))}
          </InfiniteScroll>
        ) : (
          <>
            {messageList.map((message, index) => (
              <ChatItem
                key={`ChatItem_${index}`}
                profileData={basicProfile}
                message={message}
                toDomain={toDomain}
                scrollToBottom={scrollToBottom}
                setbuyModalstatus={setbuyModalstatus}
                roomLogo={roomLogo}
              />
            ))}
          </>
        )}
        {isOtherTyping && (
          <ChatTyping profileData={basicProfile} toDomain={toDomain} />
        )}
      </>
    );
  };

  const getview = () => {
    if (isPending)
      return (
        <div className="body-container">
          <div className="dot-falling" />
        </div>
      );
    return (
      <>
        {profileModalVisible && (
          <ProfileModal
            address={toDomain}
            uuid={toDomain}
            setProfileModalVisible={setProfileModalVisible}
          />
        )}
        <div className="d2c-chat-item-user-info">
            <div aria-hidden="true" style={{ margin: "5px" }} className="d2c-brand-logo">
              {roomLogo ? (
                <img className="logo-image" src={roomLogo} />
              ) : (
                parse_url_first_letter(toDomain)
              )}
            </div>
          <div className="d2c-brand-name-header">
            <div className="d2c-brand-name-text"><span>{toDomain}</span></div>
            <VerifiedIcon
              color="primary"
              fontSize="small"
              style={{
                verticalAlign: "middle",
                margin: "-1px 0 0 4px",
              }}
            />
          </div>
        </div>
        <MessageList
          id="messagelist"
          style={{
            display: "flex",
            flexDirection: "column-reverse",
          }}
        >
          {getMessageView()}
        </MessageList>
        <BToCFloatPlugin />
        <ChatInput
          fromAddress={realAddress}
          toDomain={toDomain}
          isChatting={true}
          setlistModalstatus={setlistModalstatus}
          setAsset={setAsset}
          logoUrl={roomLogo}
        />
      </>
    );
  };
  return getview();
};

export default Chat;
